import React from 'react';

import { useUserAccountButtonQuery } from 'generated/graphql';
import { useLoading } from 'modules';



export function useUserAccountButton() {
  const query = useUserAccountButtonQuery({});
  const loading = useLoading([query]);

  return React.useMemo(() => ({
    loading,
    data: {
      isSuperAdmin: query.data?.loggedInUser?.isSuperAdmin ?? false,
      fullName: `${query.data?.loggedInUser?.firstName ?? ''} ${query.data?.loggedInUser?.lastName ?? ''}`
    }
  }), [query, loading]);
}
